interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ kicker, title, desc, align = 'left' }: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';

  return (
    <div className={`flex flex-col ${alignment} gap-3 max-w-3xl`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
        <span className="w-1.5 h-1.5 rounded-full bg-secondary-500" />
        {kicker}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
        {title}
      </h2>
      {desc ? <p className="text-sm md:text-base leading-relaxed text-foreground-700">{desc}</p> : null}
    </div>
  );
}